"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = expand;

function expand(arr, modulo) {
    var filler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var size = arr.length % modulo;

    if (size === 0 && arr.length > 0) return arr;

    var missing = modulo - size;
    var filling = new Array(missing).fill(filler);

    return arr.concat(filling);
}